import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UNSAFE_SetEnvRef from '@uie/set-env-ref';
import styled from 'styled-components';
import cuid from 'cuid';
import AnchorIconBase from './AnchorIconBase';
import TooltipPopover from './TooltipPopover';
import AnchorIcon from '../utils/AnchorIcon';
import { withVDSManager, calculateRem, checkIfMobileDevice } from '@vds-core/utilities';
import { getBrowser, getOS } from '@vds-core/utilities';
import TooltipDialog from './TooltipDialog';
var propTypes = {
  /**
   * String, React Component, or HTML to rendered as the body of the tooltip.
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),

  /**
   * @ignore
   */
  surface: PropTypes.oneOf(['light', 'dark']),

  /**
   * Size of icon
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * String, React Component, or HTML to rendered as the title of the tooltip.
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),

  /**
   * @ignore
   * Option to render icon element in brand colors
   * @note Providing a custom HEX value is also possible. Brand highlight is recommended only for use on light surfaces.
   */
  iconFillColor: PropTypes.oneOfType([PropTypes.oneOf(['primary', 'secondary', 'brandHighlight']), PropTypes.string]),

  /**
   * @ignore
   */
  getIconColor: PropTypes.func,

  /**
   * A String label that is required for accessibility, the should be very terse description ot the tooltips content.
   */
  ariaLabel: PropTypes.string,

  /**
   * Function that returns an HTML element or React component to be used as a custom anchor for the tooltip. The function is called with a React ref, and an object that will pass back aria-describedby, aria-expanded, and aria-label that has to be passed to the returned anchor element/component.
   */
  renderAnchorElement: PropTypes.func,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * Boolean that activates disabled state
   */
  disabled: PropTypes.bool,

  /**
   * Allows a unique component ID to be passed to the component as a reference for positioning other than the window object.
   */
  containerId: PropTypes.string,

  /**
   *  @ignore
   * Scrollbar prop
   */
  calculateTrackColor: PropTypes.func,

  /**
   * @ignore
   * Scrollbar prop
   */
  calculateThumbColor: PropTypes.func,

  /**
   * @ignore
   * Scrollbar prop
   */
  scrollbarBorderRadius: PropTypes.string,

  /**
   * @ignore
   * Brand 3.0 only to render the dialog styling when on mobile devices
   */
  renderTooltipDialog: PropTypes.bool,

  /**
   * @ignore
   * Brand 3.0 only. For storybook purposes
   */
  fakeMobileDevice: PropTypes.bool,

  /**
   * @ignore 3.x only
   * If provided, will render the text of the close button when on mobile/touch devices
   */
  closeButtonText: PropTypes.string,

  /**
   * @ignore 4px for 3.x and none for 1.x
   */
  tooltipBorderRadius: PropTypes.string
};
var defaultProps = {
  surface: 'light',
  size: 'medium',
  renderTooltipDialog: true,
  //added after renaming
  title: null,
  ariaLabel: 'More information',
  renderAnchorElement: null,
  disabled: false,
  fakeMobileDevice: false,
  closeButtonText: 'Close',
  tooltipBorderRadius: '4px'
};
var TooltipWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "TooltipWrapper",
  componentId: "VDS__sc-8y4bkd-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n  padding: 0;\n  outline: none;\n  ", ";\n"])), function (_ref) {
  var disabled = _ref.disabled;
  return disabled && "\n    pointer-events: none;\n    cursor: default;\n  ";
});
var TooltipIconWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "TooltipIconWrapper",
  componentId: "VDS__sc-8y4bkd-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  outline: none;\n  z-index: ", ";\n"])), function (_ref2) {
  var clicked = _ref2.clicked,
      showDialog = _ref2.showDialog,
      hovered = _ref2.hovered;
  return clicked || hovered || showDialog ? 6 : 0;
});
var CustomAnchorElementWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "CustomAnchorElementWrapper",
  componentId: "VDS__sc-8y4bkd-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  z-index: ", ";\n"])), function (_ref3) {
  var clicked = _ref3.clicked,
      showDialog = _ref3.showDialog,
      hovered = _ref3.hovered;
  return clicked || hovered || showDialog ? 6 : 0;
});
var HitArea = /*#__PURE__*/styled.span.withConfig({
  displayName: "HitArea",
  componentId: "VDS__sc-8y4bkd-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  transform: translate(-50%, -50%);\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  bottom: 50%;\n  height: ", ";\n  width: ", ";\n  z-index: 1;\n  outline: none;\n"])), calculateRem(44), calculateRem(44));
var ScreenReaderText = /*#__PURE__*/styled.span.withConfig({
  displayName: "ScreenReaderText",
  componentId: "VDS__sc-8y4bkd-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n"])));

var Tooltip = /*#__PURE__*/function (_Component) {
  _inherits(Tooltip, _Component);

  var _super = _createSuper(Tooltip);

  function Tooltip() {
    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hovered: false,
      //tracks if the mouse has entered the boundries of the component
      keyboardFocused: false,
      // controls whether or not we should show the focus indicator (keyboard users)
      showDialog: false,
      // controls the state of the dialog
      clicked: false,
      // this is to tell if someone clicked the icon, in which case, the tooltip stays open
      active: false,
      // tracks if the mouse is down on the component
      customAnchorPresent: false,
      isIe: getBrowser() === 'ie',
      scrollPosition: null,
      tooltipAnchorCoordinates: {},
      hasScrollableContent: undefined,
      unmounted: undefined
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this._resize();

      typeof document !== 'undefined' && document.addEventListener('click', _this._onClickOutside);
      typeof window !== 'undefined' && window.addEventListener('scroll', _this.setAnchorElementPositionProperties);
      typeof window !== 'undefined' && window.addEventListener('resize', _this._resize); // this check is to see if a custom element is being used as an anchor
      // this flag will activate different styles for the dialog based on the boolean

      if (_this.props.renderAnchorElement) {
        _this.setState({
          customAnchorPresent: true
        });
      }

      _this.tooltipId = cuid();
      _this.tooltipWrapperId = _this.props.id || "".concat(_this.tooltipId, "-tooltipWrapper");
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps, prevState) {
      if (prevState.showDialog !== _this.state.showDialog && _this.state.keyboardFocused) {
        if (!_this.state.showDialog) _this.setState({
          hasScrollableContent: undefined
        });
        typeof document !== 'undefined' && document.getElementById(_this.tooltipId).focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      !_this.isMobileDevice && typeof document !== 'undefined' && document.removeEventListener('click', _this._onClickOutside);
      typeof window !== 'undefined' && window.removeEventListener('scroll', _this.setAnchorElementPositionProperties);
      typeof window !== 'undefined' && window.removeEventListener('resize', _this._resize);
    });

    _defineProperty(_assertThisInitialized(_this), "setAnchorElementPositionProperties", function () {
      // get the reference to the current tooltipAnchor
      var tooltipAnchor = _this.toolTipAnchorRef;
      var tooltipAnchorRef = tooltipAnchor;
      var tooltipAnchorCoordinates = tooltipAnchorRef.getBoundingClientRect(); // assign tooltipAnchorCoordinates the value of the current anchor ref boundingClientRect

      _this.setState({
        tooltipAnchorCoordinates: tooltipAnchorCoordinates
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openDialog", function () {
      _this.setState({
        showDialog: true,
        unmounted: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeDialog", function () {
      if (_this.isMobileDevice) {
        _this.setState({
          unmounted: true
        });

        _this.unMountTimer = setTimeout(function () {
          _this.setState({
            showDialog: false,
            unmounted: false
          });
        }, 100);
      } else {
        _this.setState({
          showDialog: false,
          unmounted: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setHasScrollableContent", function (value) {
      _this.setState({
        hasScrollableContent: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_resize", function () {
      _this.setAnchorElementPositionProperties();

      _this.isMobileDevice = checkIfMobileDevice();
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyDown", function (e, focused) {
      var _this$state = _this.state,
          showDialog = _this$state.showDialog,
          keyboardFocused = _this$state.keyboardFocused,
          unmounted = _this$state.unmounted;
      var key = e.keyCode;
      var spacebar = key === 32;
      var enter = key === 13;
      var esc = key === 27;
      var tab = key === 9;
      var shift = e.shiftKey;
      /* dont scroll page when pressing space */

      if (spacebar) e.preventDefault();
      /* This will toggle the dialog/focused state based on interaction */

      if (enter || spacebar || esc && showDialog) {
        _this.setState({
          showDialog: !showDialog
        });
      } else if ((shift && tab || tab) && showDialog) {
        _this.closeDialog();
      }

      if (_this.anchorWithRef !== null && _this.anchorElementProps.props.onKeyDown) {
        _this.anchorElementProps.props.onKeyDown(e);
      }

      if (_this.anchorWithRef !== null && _this.anchorElementProps.props.onBlur) {
        _this.anchorElementProps.props.onBlur(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "scrollbarId", cuid());

    _defineProperty(_assertThisInitialized(_this), "_onClickOutside", function (e) {
      // check if current event contains ref if not close dialog
      var toolTipAnchorRef = _this.toolTipAnchorRef;

      if (toolTipAnchorRef && !toolTipAnchorRef.contains(e.target) && e.target.getAttribute('data-tooltip') !== _this.ariaId && e.target.parentNode.getAttribute('data-tooltip') !== _this.ariaId && e.target.parentNode.id !== _this.ariaId && e.target.parentNode.id !== "scrollbar-view-".concat(_this.scrollbarId) && e.target.id !== "scrollbar-view-".concat(_this.scrollbarId)) {
        _this.setState({
          scrollPosition: 0,
          keyboardFocused: false,
          clicked: false,
          showDialog: false,
          active: false,
          hovered: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseEnter", function (e) {
      if (_this.isMobileDevice) return;

      if (e.target.parentNode.id !== "scrollbar-view-".concat(_this.scrollbarId)) {
        var keyboardFocused = _this.state.keyboardFocused;

        if (keyboardFocused) {
          _this.setState({
            keyboardFocused: false
          });
        }

        _this.openTooltipTimeout = setTimeout(function () {
          _this.setState({
            showDialog: true,
            unmounted: false,
            hovered: true
          });
        }, 200);

        if (_this.anchorWithRef !== null && _this.anchorElementProps.props.onMouseEnter) {
          _this.anchorElementProps.props.onMouseEnter(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseExit", function (e) {
      if (_this.isMobileDevice) return;
      var _this$state2 = _this.state,
          clicked = _this$state2.clicked,
          showDialog = _this$state2.showDialog;

      if (clicked && showDialog) {
        return;
      } // clear time out to prevent showDialog being set to true unintentionally


      clearTimeout(_this.openTooltipTimeout);

      _this.setState({
        hovered: false,
        showDialog: false,
        keyboardFocused: false // unmounted: true

      });

      if (_this.anchorWithRef !== null && _this.anchorElementProps.props.onMouseLeave) {
        _this.anchorElementProps.props.onMouseLeave(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (e) {
      var _this$state3 = _this.state,
          clicked = _this$state3.clicked,
          hovered = _this$state3.hovered,
          showDialog = _this$state3.showDialog;
      _this.props.onClick && _this.props.onClick(e);
      /* when using JAWS + keyboard interactions are handled by
      the onClick event. If this is the case, it wont be hovered, so show the dialog. */

      var tooltipDialog = typeof document !== 'undefined' && document.getElementById("".concat(_this.tooltipId, "-dialog"));

      if (hovered) {
        clicked ? _this.setState({
          clicked: false,
          showDialog: false
        }) : _this.setState({
          clicked: true
        });
        return;
        /**
         * if youre clicking on the tooltip dialog (mobile device dialog), dont do anything.
         * this shouldnt dismiss the tooltip
         */
      } else if (tooltipDialog && tooltipDialog.contains(e.target)) {
        return;
        /**
         * if this is a mobile device and the dialog is open we need to wait for the animation to close.
         * so first, animate out, then remove the dialog from the DOM.
         */
      } else if (_this.isMobileDevice && showDialog) {
        _this.setState({
          unmounted: true
        });

        _this.animationDelay = setTimeout(function () {
          _this.setState({
            showDialog: false,
            unmounted: false
          });
        }, 100);
        /**
         * treat this as a desktop dialog. when clicking the dialog,
         */
      } else _this.setState({
        clicked: false,
        showDialog: !showDialog
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseDown", function (e) {
      _this.setState({
        active: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseUp", function (e) {
      _this.setState({
        active: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onFocus", function (e) {
      var _this$state4 = _this.state,
          hovered = _this$state4.hovered,
          keyboardFocused = _this$state4.keyboardFocused;
      /*  if the focus came from keyboard set it true, 
      if it came from mouse click, it will be set to false in _onClick */

      if (!hovered && !keyboardFocused) {
        _this.setState({
          keyboardFocused: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setAnchorElement", function () {
      var renderAnchorElement = _this.props.renderAnchorElement;
      var _this$state5 = _this.state,
          showDialog = _this$state5.showDialog,
          ariaLabel = _this$state5.ariaLabel;

      var computedProps = _objectSpread({
        ariaExpanded: showDialog,
        ariaLabel: ariaLabel
      }, _defineProperty({}, _this.refKey, function (elem) {
        return _this.toolTipAnchorRef = elem;
      }));

      if (renderAnchorElement) {
        return renderAnchorElement(computedProps);
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "_setScrollPosition", function (y) {
      _this.setState({
        scrollPosition: y
      });
    });

    _defineProperty(_assertThisInitialized(_this), "refKey", UNSAFE_SetEnvRef());

    _defineProperty(_assertThisInitialized(_this), "ariaId", "tooltip-".concat(cuid()));

    _defineProperty(_assertThisInitialized(_this), "anchorWithRef", _this.setAnchorElement());

    _defineProperty(_assertThisInitialized(_this), "anchorElementProps", _this.anchorWithRef);

    _defineProperty(_assertThisInitialized(_this), "isAppleDevice", getOS() === 'osx' || getOS() === 'ios');

    _defineProperty(_assertThisInitialized(_this), "isAndroidDevice", getOS() === 'android');

    _defineProperty(_assertThisInitialized(_this), "isFirefox", getBrowser() === 'firefox');

    _defineProperty(_assertThisInitialized(_this), "_setDialogRef", function (elem) {
      _this.tooltipDialogRef = elem;

      if (elem && elem.offsetHeight - 1 > 202) {
        _this.setState({
          scrollable: true
        });
      } else {
        _this.setState({
          scrollable: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_dialogOnKeyDown", function (e, show) {
      // Close dialog and refocus anchor on esc space or enter key press
      if (e.keyCode === 13 || e.keyCode === 32 || e.keyCode === 27) {
        e.preventDefault();
        e.stopPropagation();

        _this.setState({
          showDialog: show
        });

        _this.toolTipAnchorRef.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderTooltipPopover", function () {
      var _this$state6 = _this.state,
          scrollPosition = _this$state6.scrollPosition,
          clicked = _this$state6.clicked,
          customAnchorPresent = _this$state6.customAnchorPresent,
          isIe = _this$state6.isIe,
          tooltipAnchorCoordinates = _this$state6.tooltipAnchorCoordinates,
          showDialog = _this$state6.showDialog,
          keyboardFocused = _this$state6.keyboardFocused,
          hasScrollableContent = _this$state6.hasScrollableContent;
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          children = _this$props.children,
          title = _this$props.title,
          surface = _this$props.surface,
          containerId = _this$props.containerId,
          calculateTrackColor = _this$props.calculateTrackColor,
          calculateThumbColor = _this$props.calculateThumbColor,
          scrollbarBorderRadius = _this$props.scrollbarBorderRadius,
          tooltipBorderRadius = _this$props.tooltipBorderRadius;
      var hasAnchorElement = _this.props.renderAnchorElement ? true : false;

      if (showDialog && !disabled) {
        return /*#__PURE__*/React.createElement(TooltipPopover, {
          "data-testid": "dialog",
          scrollPosition: scrollPosition,
          setScrollPosition: _this._setScrollPosition,
          clicked: clicked,
          customAnchorElement: _this.toolTipAnchorRef,
          customAnchorPresent: customAnchorPresent,
          content: children,
          deactivateDialogState: _this.closeDialog,
          title: title,
          ariaId: _this.ariaId,
          tooltipId: _this.tooltipId,
          keyboardFocused: keyboardFocused,
          keepDialogActiveOnMouseEnter: !keyboardFocused ? _this.openDialog : null,
          toolTipAnchorRef: _this.toolTipAnchorRef,
          showDialog: showDialog,
          surface: surface,
          isIe: isIe,
          containerId: containerId,
          tooltipWrapperId: _this.tooltipWrapperId,
          tooltipAnchorCoordinates: tooltipAnchorCoordinates,
          isIOS: _this.isAppleDevice,
          onKeyDown: _this._dialogOnKeyDown,
          setRef: _this._setDialogRef,
          setHasScrollableContent: _this.setHasScrollableContent,
          hasScrollableContent: hasScrollableContent,
          hasAnchorElement: hasAnchorElement,
          isFirefox: _this.isFirefox,
          onTabKeyPress: _this.closeDialog,
          scrollbarId: _this.scrollbarId,
          scrollbarBorderRadius: scrollbarBorderRadius,
          calculateThumbColor: calculateThumbColor,
          calculateTrackColor: calculateTrackColor,
          tooltipBorderRadius: tooltipBorderRadius
        });
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderMobileTooltipDialog", function () {
      var _this$state7 = _this.state,
          showDialog = _this$state7.showDialog,
          unmounted = _this$state7.unmounted;
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          surface = _this$props2.surface,
          children = _this$props2.children,
          closeButtonText = _this$props2.closeButtonText;

      if (showDialog && !disabled) {
        return /*#__PURE__*/React.createElement(TooltipDialog, _extends({}, _this.props, {
          closeButtonText: closeButtonText,
          dialogId: "".concat(_this.tooltipId, "-dialog"),
          dialogOpened: showDialog,
          surface: surface,
          body: children,
          onClick: _this.closeDialog,
          unmounted: unmounted,
          isAndroidDevice: _this.isAndroidDevice
        }));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderIconAnchorElement", function () {
      var _this$props3 = _this.props,
          colorConfig = _this$props3.colorConfig,
          disabled = _this$props3.disabled,
          ariaLabel = _this$props3.ariaLabel,
          size = _this$props3.size,
          surface = _this$props3.surface,
          iconFillColor = _this$props3.iconFillColor,
          getIconColor = _this$props3.getIconColor,
          renderTooltipDialog = _this$props3.renderTooltipDialog,
          fakeMobileDevice = _this$props3.fakeMobileDevice;
      var _this$state8 = _this.state,
          clicked = _this$state8.clicked,
          showDialog = _this$state8.showDialog,
          hovered = _this$state8.hovered,
          isIe = _this$state8.isIe,
          keyboardFocused = _this$state8.keyboardFocused,
          active = _this$state8.active,
          hasScrollableContent = _this$state8.hasScrollableContent;
      var tooltipDialogComponent = renderTooltipDialog && (_this.isMobileDevice || fakeMobileDevice) ? _this.renderMobileTooltipDialog() : _this.renderTooltipPopover();
      return /*#__PURE__*/React.createElement(TooltipIconWrapper, {
        tabIndex: _this.isAndroidDevice ? undefined : -1,
        importantForAccessibility: "no",
        clicked: clicked,
        showDialog: showDialog,
        hovered: hovered,
        onMouseLeave: disabled ? undefined : _this._onMouseExit,
        onMouseEnter: disabled ? undefined : _this._onMouseEnter
      }, /*#__PURE__*/React.createElement(AnchorIconBase, _extends({
        mobile: _this.isMobileDevice,
        tabIndex: 0,
        "data-testid": "tooltip",
        id: _this.tooltipId,
        colorConfig: colorConfig,
        "aria-expanded": !_this.isMobileDevice && hasScrollableContent === undefined ? false : _this.isMobileDevice && showDialog || hasScrollableContent && !_this.isFirefox && !isIe ? undefined : showDialog,
        "aria-label": isIe || _this.isAndroidDevice ? undefined : ariaLabel,
        hovered: hovered,
        clicked: clicked,
        onFocus: !disabled ? _this._onFocus : undefined,
        onMouseDown: disabled ? undefined : _this._onMouseDown,
        onMouseUp: disabled ? undefined : _this._onMouseUp,
        onClick: disabled ? undefined : _this._onClick,
        showDialog: showDialog,
        size: size,
        surface: surface,
        keyboardFocused: keyboardFocused,
        disabled: disabled
      }, _defineProperty({}, _this.refKey, function (elem) {
        return _this.toolTipAnchorRef = elem;
      })), isIe || _this.isAndroidDevice && /*#__PURE__*/React.createElement(ScreenReaderText, null, ariaLabel), /*#__PURE__*/React.createElement(ScreenReaderText, {
        "aria-live": "assertive"
      }, hasScrollableContent && !isIe && "".concat(showDialog ? _this.isFirefox ? '' : 'expanded' : 'collapsed')), /*#__PURE__*/React.createElement("span", {
        tabIndex: -1,
        style: {
          outline: 'none',
          display: 'inline-flex'
        }
      }, /*#__PURE__*/React.createElement(AnchorIcon, {
        tabIndex: -1,
        iconFillColor: iconFillColor,
        getIconColor: getIconColor,
        colorConfig: colorConfig,
        disabled: disabled,
        onClick: _this._onclick,
        importantForAccessibility: "no",
        size: size,
        showDialog: showDialog,
        surface: surface,
        clicked: clicked,
        hovered: hovered,
        keyboardFocused: keyboardFocused,
        active: active,
        ariaLabel: ariaLabel
      }), !_this.props.disabled && /*#__PURE__*/React.createElement(HitArea, {
        tabIndex: -1,
        "aria-hidden": true,
        importantForAccessibility: "no",
        "data-testid": "hit-area"
      }))), /*#__PURE__*/React.createElement("span", {
        "aria-live": !_this.isMobileDevice ? 'assertive' : undefined
      }, tooltipDialogComponent));
    });

    _defineProperty(_assertThisInitialized(_this), "renderCustomAnchorElement", function () {
      var anchorWithRef = _this.setAnchorElement();

      var _this$props4 = _this.props,
          disabled = _this$props4.disabled,
          ariaLabel = _this$props4.ariaLabel,
          renderTooltipDialog = _this$props4.renderTooltipDialog,
          viewport = _this$props4.viewport,
          fakeMobileDevice = _this$props4.fakeMobileDevice;
      var _this$state9 = _this.state,
          clicked = _this$state9.clicked,
          showDialog = _this$state9.showDialog,
          hovered = _this$state9.hovered,
          isIe = _this$state9.isIe,
          hasScrollableContent = _this$state9.hasScrollableContent;
      var tooltipDialogComponent = renderTooltipDialog && (_this.isMobileDevice || fakeMobileDevice) ? _this.renderMobileTooltipDialog() : _this.renderTooltipPopover();
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CustomAnchorElementWrapper, _extends({}, _defineProperty({}, _this.refKey, function (elem) {
        return _this.toolTipAnchorRef = elem;
      }), {
        "aria-label": isIe ? undefined : ariaLabel,
        onMouseEnter: disabled ? undefined : _this._onMouseEnter,
        onMouseDown: disabled ? undefined : _this._onMouseDown,
        onMouseLeave: disabled ? undefined : _this._onMouseExit,
        onMouseUp: disabled ? undefined : _this._onMouseUp,
        onClick: disabled ? undefined : _this._onClick,
        onFocus: !disabled ? _this._onFocus : undefined,
        "aria-expanded": _this.isMobileDevice && showDialog ? undefined : showDialog,
        clicked: clicked,
        showDialog: showDialog,
        hovered: hovered
      }), /*#__PURE__*/React.createElement(ScreenReaderText, {
        "aria-live": "assertive"
      }, hasScrollableContent && "".concat(showDialog ? _this.isFirefox || isIe ? '' : 'expanded' : 'collapsed')), /*#__PURE__*/React.createElement("div", {
        tabIndex: -1
      }, /*#__PURE__*/React.cloneElement(anchorWithRef, {
        onKeyDown: !disabled ? _this._onKeyDown : undefined,
        id: _this.tooltipId,
        'aria-expanded': showDialog
      }))), /*#__PURE__*/React.createElement("span", {
        "aria-live": !_this.isMobileDevice ? 'assertive' : undefined
      }, tooltipDialogComponent));
    });

    return _this;
  }

  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var className = this.props.className;
      return /*#__PURE__*/React.createElement(TooltipWrapper, {
        id: this.tooltipWrapperId,
        className: className,
        trailing: this.props.trailing,
        tabIndex: this.isAndroidDevice ? undefined : -1
      }, this.props.renderAnchorElement ? this.renderCustomAnchorElement() : this.renderIconAnchorElement());
    }
  }]);

  return Tooltip;
}(Component);

Tooltip.defaultProps = defaultProps;
Tooltip.propTypes = propTypes;
export default withVDSManager(Tooltip);